export default __webpack_public_path__ + "static/logo-white-f027ca90659f3bed85c16917ee83cc74.svg";